import { Checkbox, Css } from "@homebound/beam";
import { showPBBv2Personalization } from "src/features";
import { PotentialBidPlanDimensionKind } from "src/generated/graphqlTypes";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";

type DimensionTypeCheckboxesProps = {
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
  selectedTypeIds: string[];
  onChange: (typeIds: string[]) => void;
};

export function DimensionTypeCheckboxes(props: DimensionTypeCheckboxesProps) {
  const { dimensionResults, selectedTypeIds, onChange } = props;
  function toggle(typeId: string, selected: boolean) {
    onChange(selected ? [...selectedTypeIds, typeId] : selectedTypeIds.filter((id) => id !== typeId));
  }
  // Only type-based (GlobalOptionType) dimensions render as checkboxes; personalization uses the multi-select.
  const typeResults = dimensionResults.filter((r) => r.kind === PotentialBidPlanDimensionKind.GlobalOptionType);
  return (
    <div css={Css.df.fdc.gap3.if(!showPBBv2Personalization).mb1.$}>
      {typeResults.map((r) => (
        <Checkbox
          key={r.type!.id}
          label={r.type!.name}
          selected={selectedTypeIds.includes(r.type!.id)}
          onChange={(next) => toggle(r.type!.id, next)}
        />
      ))}
    </div>
  );
}
